export const Attendance = {
    attence:{
        '考勤':'考勤',
        '传统考勤':'传统考勤',
        '数字考勤':'数字考勤',
        'GPS考勤':'GPS考勤',
        '二维码考勤':'二维码考勤',
        "扫码考勤":"扫码考勤",
        '签入签出考勤':'签入签出考勤',
        '系统提示':'系统提示',
        '本次考勤为扫码考勤':'本次考勤为扫码考勤，请您用微信扫一扫老师的大屏幕的二维码进行签到',
        '签到成功':'签到成功',
        '签出成功':'签出成功',
        '未到签出时间':'未到签出时间',
        '还未到签出时间':'还未到签出时间',
        '此时签出视为早退':'此时签出视为早退',
        "新建考勤":"新建考勤",
        "考勤名称":"考勤名称",
        "请输入考勤名称":"请输入考勤名称",
        "选择考勤方式":"选择考勤方式",
        "编辑考勤名称":"编辑考勤名称",
        "编辑考勤":"编辑考勤",
        "删除考勤":"删除考勤",
        "查看GPS与可疑代签":"查看GPS与可疑代签",
        "取消考勤":"取消考勤",
        "确定要删除本次考勤吗":"确定要删除本次考勤吗?",
        "异常签到":"异常签到",
        "可疑代签":"可疑代签",
        "GPS":"GPS",
        "无异常签到成员":"无异常签到成员",
        "学员信息":"学员信息",
        "考勤状态":"考勤状态",
        "可疑代签情况":"可疑代签情况",
        "同账号多设备登录":"同账号多设备登录",
        "没有发现代签的学生":"没有发现代签的学生耶！",
        "暂无学生GPS签到记录":"暂无学生GPS签到记录",
        "签到正常":"签到正常",
        "放弃":"放弃",
        "结束":"结束",
        "结束并完成此次考勤":"结束并完成此次考勤？",
        "考勤结束后老师可手动修改未签到学生考勤状态":"考勤结束后，老师可手动修改未签到学生考勤状态。",
        "放弃此次考勤":"放弃此次考勤？",
        "放弃此次考勤后此次考勤数据将清零":"放弃此次考勤后，此次考勤数据将清零。",
        "学生通过以下数字完成签到":"学生通过以下数字完成签到",
        "更换一个":"更换一个",
        "学生通过微信扫一扫该二维码完成签到":"学生通过微信扫一扫该二维码完成签到",
        "签到时间":"签到时间",
        "签到人":"签到人",
        "请选择考勤方式":"请选择考勤方式",
        "查看未签到":"查看未签到",
        "未签到":"未签到",
        "已签到":"已签到",
        "未签入":"未签入",
        "已签入":"已签入",
        "未签出":"未签出",
        "已签出":"已签出",
        "暂无学生":"暂无学生",
        "都到齐了":"都到齐了",
        "还没有学生签到":"还没有学生签到",
        "没有匹配的学生":"没有匹配的学生",
        "未命名学生":"未命名学生",
        "搜索姓名或学号":"搜索姓名或学号",
    },
    status: {
        '全部': '全部',
        '旷课': '旷课',
        '出勤': '出勤',
        '缺勤': '缺勤',
        '迟到': '迟到',
        '请假': '请假',
        '早退': '早退',
        '事假': '事假',
        '病假': '病假',
        '公假': '公假',
        '待签到':'待签到',
    },
    checkInCheckOut:{
        '签入迟到':'签入迟到',
        '签入考勤':'签入考勤',
        '签出考勤':'签出考勤',
        '签到':'签到',
        "考勤时长":"考勤时长",
        "考勤结果":"考勤结果",
        "小时":"小时",
        "分钟":"分钟",
        "分钟后考勤自动结束":"分钟后考勤自动结束",
        "下次考勤时间":"下次考勤时间",
        "到时自动通知考勤":"到时自动通知考勤",
        "请设置":"请设置",
        "开始考勤":"开始考勤",
        "请输入持续考勤时间":"请输入持续考勤时间",
        "请选择下次考勤时间":"请选择下次考勤时间",
    },
    checkInCodeResult:{
        '签到失败':'签到失败',
        '此签到二维码已过期失效':'此签到二维码已过期失效，请重新扫最新',
        '签到二维码签到':'签到二维码签到',
        '重新扫码':'重新扫码',
        '该考勤不是二维码考勤':'该考勤不是二维码考勤，无法进行扫码签到',
        '返回考勤列表':'返回考勤列表',
        '本次考勤已结束':'本次考勤已结束，无法完成签到',
        '老师已停止加课':'老师已停止加课，您无法加入课程进行签到',
        '具体情况请咨询任课老师':'具体情况请咨询任课老师',
        '无效签到':'无效签到',
        '您是课程老师':'您是课程老师，不需要进行该课程考勤',
        '您是该课程老师助教':'您是该课程老师/助教，不需要进行该课程考勤',
        '本课程人数已达到设定的课程人数上限':'本课程人数已达到设定的课程人数上限，您',
        '无法加入课程进行签到':'无法加入课程进行签到，具体情况请咨询任课老师',
        '返回课程列表':'返回课程列表',
        '恭喜您签到成功':'恭喜您签到成功',
        '您可在考勤列表页查看考勤结果':'您可在考勤列表页查看考勤结果',
        '同时您已成功加入课程':'同时您已成功加入课程',
        '重复签到':'重复签到',
        '您已参与过本次扫码签到':'您已参与过本次扫码签到，签到结果将以',
        '首次签到时间为准':'首次签到时间为准，您可在考勤列表查看',
        '本次考勤已被删除':'本次考勤已被删除',
        '未知原因':'未知原因，请重新签到',
        '访问不合法':'访问不合法',
        '请您用微信扫一扫老师的大屏幕的二维码':'请您用微信扫一扫老师的大屏幕的二维码,即可完成签到',
        '知道啦':'知道啦',
        '签到结果':"签到结果",
        '仅已认证身份并在选课名单中的成员才能参与本次考勤':'仅已认证身份并在选课名单中的成员才能参与本次考勤，请先认证身份并与老师核实本账号是否在选课名单中',
        '请输入数字':'请输入数字，手动完成签到',
        '数字由老师处获取':'数字由老师处获取',
        '点击签到':'点击签到',
        '定位准确':'定位准确',
        '定位错误':'定位错误',
        '重新定位':'重新定位',
        "正在定位中":"正在定位中。。。",
        "定位失败没有权限获取到地理位置请先开启GPS并且授权软件使用!这样可以提高定位的准确度":"定位失败，没有权限获取到地理位置，请先开启GPS，并且授权软件使用!这样可以提高定位的准确度",
        "通过微信获取地理位置信息成功":"通过微信获取地理位置信息成功...",
        "GPS位置信息获取失败您是否还要继续签到如果您继续签到的话老师那边将会显示异常签到":"GPS位置信息获取失败，您是否还要继续签到？如果您继续签到的话，老师那边将会显示异常签到！",
        "需要重新定位如果位置持续不准确可能您未打开GPS和授权允许":"需要重新定位？如果位置持续不准确，可能您未打开GPS和授权允许",
        "正在重新定位中":"正在重新定位中...",
        "通过微信成功获取GPS地理位置信息":"通过微信，成功获取GPS地理位置信息",
        "通过微信地理位置坐标转换完毕":"通过微信,地理位置坐标转换完毕",
        "定位成功":"定位成功",
    },
    "考勤持续时间":"考勤持续时间",

}